// extracted by mini-css-extract-plugin
export default {"default":"default__LS3i9","outline":"outline__qvMHH default__LS3i9"};